import { NetworkDashboardWidgetType } from '../../dashboard/widgetModel';
import { DashboardCanvas } from '@/components/dashboard/DashboardCanvas';
import { DashboardDateControl } from '@/components/dashboard/DashboardDateControl';
import { dashboardT } from '../../../../../lib/messages';
import { defaultNetworkDashboardDocument } from '../../dashboard/defaultNetworkDashboard';
import { useNetworkDashboardQueries } from '../../dashboard/hooks';
import { useNetworkDashboardRouteFilters } from '../../dashboard/useNetworkDashboardRouteFilters';
import { networkDashboardWidgetRegistry } from '../../dashboard/widgetRegistry';

export function NetworkDashboard({ networkId }: { networkId: string }) {
  const { range, setRange } = useNetworkDashboardRouteFilters();
  const queries = useNetworkDashboardQueries(networkId, range);
  return (
    <div className="min-w-0 space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-lg font-semibold">
          {dashboardT('networkDashboard.performanceOverview')}
        </h2>
        <DashboardDateControl
          showDayNavigation={range.dateFrom === range.dateTo}
          value={range}
          onChange={setRange}
        />
      </div>
      <DashboardCanvas
        document={{
          ...defaultNetworkDashboardDocument,
          widgets: defaultNetworkDashboardDocument.widgets.filter(
            (widget) => range.preset || widget.type !== NetworkDashboardWidgetType.PerformanceChart,
          ),
        }}
        registry={networkDashboardWidgetRegistry}
        runtime={{ range, ...queries }}
      />
    </div>
  );
}
